export default __webpack_public_path__ + "static/media/0177.921a797a.jpg";